import { useEffect, useEffectEvent } from 'react'
import { z } from 'zod'
import { REQUESTED_TENANT_PARAM } from '../session/requestedTenant'
import { messageSource } from './tenantChannel'

export const PUSH_OPEN_PATH = 'rp-open-path'

const APP_PATH = /^\/(?![/\\])/

const OpenRequest = z.object({ type: z.literal(PUSH_OPEN_PATH), path: z.string().regex(APP_PATH) })

const inAppHref = (path: string, tenantId: string): string | null => {
  const url = new URL(path, window.location.origin)
  if (url.origin !== window.location.origin) return null
  const hinted = url.searchParams.get(REQUESTED_TENANT_PARAM)
  if (hinted !== null && hinted !== tenantId) return null
  url.searchParams.delete(REQUESTED_TENANT_PARAM)
  return `${url.pathname}${url.search}${url.hash}`
}

export const useOpenPathsFromPush = (tenantId: string, open: (href: string) => void): void => {
  const handle = useEffectEvent((event: MessageEvent) => {
    const request = OpenRequest.safeParse(event.data)
    const href = request.success ? inAppHref(request.data.path, tenantId) : null
    if (href === null) return
    open(href)
    event.ports[0]?.postMessage({ opened: true })
  })

  useEffect(() => {
    const container = messageSource()
    if (container === null) return
    const listener = (event: Event) => handle(event as MessageEvent)
    container.addEventListener('message', listener)
    return () => container.removeEventListener('message', listener)
  }, [])
}
